import { Badge } from './badge'

const ReassignmentStatus = {
  INITIATED: 'initiated',
  APPROVED: 'approved',
  DENIED: 'denied',
  ASSIGNED_TO_CC: 'assigned_to_cc',
} as const

type BadgeColor = 'gold' | 'mint' | 'orange' | undefined

interface ReassignmentStatusBadgeProps {
  status: string
  familyInitiated?: boolean
  canReview?: boolean
}

/**
 * Displays a status badge for a reassignment.
 *
 * @param status - The reassignment status
 * @param familyInitiated - Whether the reassignment was family initiated (for auto-approved label)
 * @param canReview - Whether the current user can review (affects "To Review" vs "Pending Review" label)
 */
export function ReassignmentStatusBadge({
  status,
  familyInitiated = false,
  canReview = false,
}: ReassignmentStatusBadgeProps) {
  let label: string
  let color: BadgeColor

  switch (status) {
    case ReassignmentStatus.INITIATED:
      label = canReview ? 'To Review' : 'Pending Review'
      color = undefined
      break
    case ReassignmentStatus.ASSIGNED_TO_CC:
      label = 'Assigned to CC'
      color = 'gold'
      break
    case ReassignmentStatus.APPROVED:
      label = familyInitiated ? 'Auto-approved' : 'Approved'
      color = 'mint'
      break
    case ReassignmentStatus.DENIED:
      label = 'Denied'
      color = 'orange'
      break
    case 'cancelled':
      label = 'Cancelled'
      color = 'orange'
      break
    default:
      label = status
      color = undefined
  }

  return <Badge label={label} color={color} />
}
